import { useState } from 'react';
import { categories } from '@/mocks/categories';
import { categoryImages } from '@/components/feature/Navbar';

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    setSelectedCategory(url);
    if (url) {
      window.open(url, '_blank', 'noopener,nofollow');
      setSelectedCategory('');
    }
  };

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Product <span className="text-primary-500">Categories</span>
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto mb-8">
            Browse our complete collection of product categories with updated buying guides and links.
          </p>

          {/* Dropdown Selector */}
          <div className="max-w-md mx-auto">
            <label htmlFor="category-select" className="block text-sm font-medium text-foreground-600 mb-2 text-left">
              Quick jump to a category:
            </label>
            <div className="relative">
              <select
                id="category-select"
                value={selectedCategory}
                onChange={handleDropdownChange}
                className="w-full appearance-none bg-background-50 border-2 border-background-300 rounded-xl px-4 py-3 pr-10 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors cursor-pointer font-medium"
              >
                <option value="">Select a category...</option>
                {categories.map((cat) => (
                  <option key={cat.name} value={cat.url}>
                    {cat.name} ({cat.items} items)
                  </option>
                ))}
              </select>
              <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Category Grid with Images */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-50 rounded-2xl border-2 border-background-200/70 hover:border-primary-300 transition-all cursor-pointer overflow-hidden"
            >
              {/* Category Image */}
              <div className="relative w-full h-36 overflow-hidden bg-background-100">
                <img
                  src={categoryImages[cat.name] || ''}
                  alt={cat.name}
                  title={`${cat.name} – VigorBuy Spreadsheet Category`}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Category Info */}
              <div className="p-3 md:p-4 text-center flex flex-col items-center justify-center flex-1">
                <span className="font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500 mt-1">
                  {cat.items} items
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}